/* eslint-disable max-len */
import {
  Button, Card, FormControl, FormControlLabel, Grid, Radio, RadioGroup,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import { ObjectSchema } from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import RequiredFiled from '../../../../Common/RequiredField';
import CustomCheckbox from '../../../../Common/ComponentCustomCheckBox';
import ComponentTextInput from '../../../../Common/ComponentTextinput/ComponentTextInput';
import ComponentSelectInput from '../../../../Common/ComponentSelectInput';
import { UnitInfoOrderFormValues } from '../../utils/types';
import { CLIENT_SITE_TAB, JobOrderMainDefaultValue, UnitInfoOrderFormNames } from '../../utils/constants';
import { RootState } from '../../../../redux/rootState';
import { pctRegex } from '../../../../utils/regex';
import { AddPlaylist, DeleteIcon } from '../../../../assets/TableIcons';
import styles from '../../utils/style.module.scss';
import { getUnitMasterStart, getVesselMasterStart } from '../../../Job/ScreenUnitInformation/redux/unitInfoSlice';
import { getAnalystMasterStart } from '../../../Job/ScreenBidWorkSheetJob/redux/bidWorksheetSlice';
import { CommonDateInput } from '../../../../Common/CommonDateInput';
import { assignJobOrderMain, assignMain, getValidationSchema } from '../../utils/helper';
import {
  getJobOrderById, jobOrderMainForm, setSelectedTab,
} from '../../redux/sliceJobOrder';
import { Empty } from '../../../ScreenAddSmc/Utils/TypeSmc';
import EndPoints from '../../../../Routes/EndPoints';
import ComponentSelectInputInspectedBy from '../ComponentSelectInputInspectedBy';

function ScreenMain({ manualSave, setManual }: { manualSave: string, setManual: () => void }) {
  const {
    JobOrderMainData, mainFormData, IsJobCompleted, IsNewJob, IsSmallTubeEnabled,
  } = useSelector((state: RootState) => state.jobOrderReducer);
  const {
    control, watch, formState: { errors }, handleSubmit, setValue, reset, trigger,
  } = useForm<UnitInfoOrderFormValues>({
    defaultValues: JobOrderMainDefaultValue,
    resolver: yupResolver(getValidationSchema(!!JobOrderMainData?.IsMigrated, IsNewJob, IsSmallTubeEnabled) as unknown as ObjectSchema<UnitInfoOrderFormValues>),
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orderId } = useParams();
  const [error, setError] = useState('');

  const {
    unitMaster, machineType,
  } = useSelector((state: RootState) => state.unitInfoReducer);
  const { signatureData } = useSelector((state: RootState) => state.reportWorkspaceReducer);
  const { analystList } = useSelector((state: RootState) => state.bidsReducer);
  const testType = watch(UnitInfoOrderFormNames.testType);
  const spotTest = watch(UnitInfoOrderFormNames.spotTest);
  const od = watch(UnitInfoOrderFormNames.odTubes);
  // const [inspectedByFieldsArray, setinspectedByFieldsArray] = useState([]);
  const onSubmit = (values: UnitInfoOrderFormValues) => {
    dispatch(jobOrderMainForm(values));
    if (manualSave.length > 0) {
      dispatch(setSelectedTab(Number(manualSave)));
    } else if (manualSave.length === 0) {
      dispatch(setSelectedTab(CLIENT_SITE_TAB));
    }
    reset();
  };

  useEffect(() => {
    if (manualSave.length > 0) {
      handleSubmit(onSubmit)();
      setTimeout(() => {
        setManual();
      }, 2000);
    }
  }, [manualSave]);

  useEffect(() => {
    if (IsSmallTubeEnabled && IsNewJob && testType === UnitInfoOrderFormNames.absolute) {
      if (od && (Number(od) < 0.5)) {
        setValue(UnitInfoOrderFormNames.isSmallTubeJO, true);
      } else {
        setValue(UnitInfoOrderFormNames.isSmallTubeJO, false);
      }
    } else {
      setValue(UnitInfoOrderFormNames.isSmallTubeJO, false);
    }
  }, [od, testType, IsNewJob, IsSmallTubeEnabled]);

  const signatures = useMemo(() => {
    const restructred = signatureData?.map((sig) => ({ Value: sig.Text, Text: sig.Text }));
    restructred.push({ Value: 'TECHNICAL MANAGER, LEVEL III', Text: 'TECHNICAL MANAGER, LEVEL III' });
    return restructred;
  }, [signatureData]);

  // const handleChange = () => {
  //   const values = getValues();
  //   dispatch(jobOrderMainForm(values));
  // };

  useEffect(() => {
    dispatch(getUnitMasterStart());
    dispatch(getAnalystMasterStart());
    dispatch(getVesselMasterStart());
    // return () => {
    //   dispatch(resetJobOrderMain());
    // };
  }, []);

  const handleTestTypeChange = (value: string) => {
    // setValue(UnitInfoOrderFormNames.odTubes, '');
    if (value !== 'FLT' && value !== 'ADT') {
      trigger(UnitInfoOrderFormNames.odTubes);
    }
  };

  const handlePCTChange = (value : boolean) => {
    setValue(UnitInfoOrderFormNames.pct, '');
    if (value === false) {
      trigger(UnitInfoOrderFormNames.pct);
    }
  };

  useEffect(() => {
    // Check if form data is already available in Redux
    if (orderId && Object.keys(mainFormData).length === 0) {
      dispatch(getJobOrderById({ id: orderId }));
    }
  }, [mainFormData, orderId]);

  const { fields, append, remove } = useFieldArray<Empty>({
    control,
    name: UnitInfoOrderFormNames.inspectedBy,
  });

  useEffect(() => {
    if (mainFormData && Object.keys(mainFormData).length > 0) {
      assignMain(setValue, mainFormData);
      if (JobOrderMainData?.IsMigrated) {
        setValue(UnitInfoOrderFormNames.inspectedBy, [mainFormData.inspectedBy]?.join(', '));
      } else {
        setValue(UnitInfoOrderFormNames.inspectedBy, mainFormData.inspectedBy);
      }
    } else if (JobOrderMainData) {
      // dispatch(jobOrderMainForm(watch()));
      const filteredData = JobOrderMainData?.InspectedBy?.map((name) => (analystList?.some((item) => item?.Value?.trim() === name?.trim()) ? (analystList?.find((item) => item?.Value?.trim() === name?.trim()))?.Text || '' : name.trim()));
      // const filteredData = JobOrderMainData?.InspectedBy?.map((name) => (analystList?.some((item) => item?.Text?.trim() === name?.trim()) ? name.trim() : name.trim()));
      // const filteredData = JobOrderMainData?.InspectedBy?.map((name) => (analystList?.some((item) => item?.Text?.trim() === name?.trim()) ? name.trim() : ''));
      assignJobOrderMain(setValue, JobOrderMainData);
      if (JobOrderMainData?.IsMigrated) {
        setValue(UnitInfoOrderFormNames.inspectedBy, JobOrderMainData?.InspectedBy?.join(', '));
      } else {
        setValue(UnitInfoOrderFormNames.inspectedBy, filteredData);
      }
    }
  }, [JobOrderMainData, mainFormData, analystList]);

  // useEffect(() => {
  //   dispatch(getSerialNoStart());
  // }, []);
  const startDate = watch(UnitInfoOrderFormNames.startDate);
  const endDate = watch(UnitInfoOrderFormNames.endDate);
  const buttonDisabled = useMemo(() => {
    if (endDate && startDate) {
      const isErr = endDate?.isBefore(startDate);
      if (isErr) {
        setError('The start date cannot occur after the end date.');
        return isErr;
      }
      setError('');
      return isErr;
    } setError('');
    return false;
  }, [endDate, startDate]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid item md={12} sm={12} xs={12} style={{ marginBottom: '20px' }}>
        <Card>
          <div className="customerInfo_container">
            <div className="customerInfo">
              Test
            </div>
            <div className="double_checkbox">
              {/* <CustomCheckbox
                control={control}
                name={UnitInfoOrderFormNames.readyToSend}
                // handleChange={handleChange}
                label="Ready To Send"
              /> */}
              <CustomCheckbox
                control={control}
                name={UnitInfoOrderFormNames.ASMESection}
                label="ASME Section V"
                // handleChange={handleChange}
                defaultValue={false}
                isDisable={!IsJobCompleted}
              />
              {IsSmallTubeEnabled && IsNewJob && testType === UnitInfoOrderFormNames.absolute && (
                <CustomCheckbox
                  control={control}
                  name="isSmallTubeJO"
                  label="Is Small Tube?"
                  isDisable
                />
              )}
            </div>
          </div>
          <div className="customerInfo_main_container">
            <Grid container spacing={2}>
              <Grid item md={9} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">&nbsp;</label>
                  <Controller
                    name={UnitInfoOrderFormNames.testType}
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange } }) => (
                      <FormControl>
                        <RadioGroup
                          row
                          value={testType}
                          key={testType}
                          // defaultValue={UnitInfoOrderFormNames.flux}
                          onChange={(event) => {
                            onChange(event);
                            handleTestTypeChange(event.target.value);
                            // handleChange();
                          }}
                        >
                          <div className="type_of_test">
                            <FormControlLabel
                              labelPlacement="start"
                              disabled={!IsJobCompleted}
                              value={UnitInfoOrderFormNames.crossaxial}
                              control={<Radio color="success" />}
                              label={<span className="radio_button_style">Crossaxial</span>}
                            />
                          </div>
                          <div className="type_of_test">
                            <FormControlLabel
                              labelPlacement="start"
                              disabled={!IsJobCompleted}
                              value={UnitInfoOrderFormNames.flux}
                              control={<Radio color="success" />}
                              label={<span className="radio_button_style">Flux</span>}
                            />
                          </div>
                          <div className="type_of_test">
                            <FormControlLabel
                              labelPlacement="start"
                              disabled={!IsJobCompleted}
                              value={UnitInfoOrderFormNames.absolute}
                              control={<Radio color="success" />}
                              label={<span className="radio_button_style">Absolute</span>}
                            />
                          </div>
                        </RadioGroup>
                      </FormControl>
                    )}
                  />
                </div>
              </Grid>
              {
                (testType === UnitInfoOrderFormNames.flux || (testType === UnitInfoOrderFormNames.absolute && IsNewJob && IsSmallTubeEnabled)) ? (
                  <Grid item md={3} sm={6} xs={12}>
                    <div className="div_label_text">
                      <label className="label_Style_job">
                        OD of Tubes
                        <RequiredFiled />
                      </label>
                      <ComponentTextInput
                        control={control}
                        name={UnitInfoOrderFormNames.odTubes}
                        type="number"
                        regEx={/^(?:\d+|\d*\.\d{1,4})$/}
                        // regEx={/^\d+(\.\d{0,3})?$/}
                        id={UnitInfoOrderFormNames.odTubes}
                        size="small"
                        errors={errors}
                        isDisable={!IsJobCompleted}
                      // handleChange={handleChange}
                      />
                    </div>
                  </Grid>
                ) : ''
              }
            </Grid>
          </div>
        </Card>
      </Grid>
      <Grid item md={12} sm={12} xs={12} style={{ marginBottom: '20px' }}>
        <Card>
          <div className="double_checkbox_container">
            <CustomCheckbox isDisable={!IsJobCompleted} name={UnitInfoOrderFormNames.leak} label="Leak" control={control} />
            <CustomCheckbox isDisable={!IsJobCompleted} name={UnitInfoOrderFormNames.outside} label="Outside" control={control} />
            <CustomCheckbox isDisable={!IsJobCompleted} name={UnitInfoOrderFormNames.safetyClass} label="Safety Class / Gear" control={control} />
            <CustomCheckbox isDisable name={UnitInfoOrderFormNames.testedBefore} label="Tested Before" control={control} />
            <CustomCheckbox isDisable={!IsJobCompleted} name={UnitInfoOrderFormNames.informedCust} label="Informed  Cust" control={control} />
          </div>
          <div className="customerInfo_main_container">
            <Grid container spacing={2}>
              <Grid item md={4} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Start Date
                  </label>
                  <CommonDateInput
                    control={control}
                    errors={errors}
                    disabled={!IsJobCompleted}
                    // handleChange={handleChange}
                    name={UnitInfoOrderFormNames.startDate}
                  />
                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    End Date
                  </label>
                  <CommonDateInput
                    control={control}
                    errors={errors}
                    disabled={!IsJobCompleted}
                    // handleChange={handleChange}
                    name={UnitInfoOrderFormNames.endDate}
                  />
                  {error.length > 0 && (
                  <div className="add_schedule_error">
                    <p>{error}</p>
                  </div>
                  )}
                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">Job Time </label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name={UnitInfoOrderFormNames.jobTime}
                    id={UnitInfoOrderFormNames.jobTime}
                    // handleChange={handleChange}
                    // regEx={/^[A-Za-z ]{1,10}$/}
                    size="small"
                    isDisable={!IsJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12} style={{ display: 'none' }}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Re-Test Date
                  </label>
                  <CommonDateInput
                    control={control}
                    errors={errors}
                    // handleChange={handleChange}
                    name={UnitInfoOrderFormNames.reTestDate}
                    disabled={!IsJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Location (Building)
                  </label>
                  <ComponentTextInput
                    control={control}
                    name={UnitInfoOrderFormNames.location}
                    id={UnitInfoOrderFormNames.location}
                    // handleChange={handleChange}
                    className="nonCapitalizeField"
                    regEx={/^[a-zA-Z0-9!@#$%^&*()_+{}[\]:;<>,.?~\\-\\/ ]{1,35}$/}
                    size="small"
                    isDisable={!IsJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_disabled">Send Report To</label>
                  <ComponentTextInput
                    control={control}
                    isDisable
                    // handleChange={handleChange}
                    name={UnitInfoOrderFormNames.sendReportTo}
                    id={UnitInfoOrderFormNames.sendReportTo}
                    size="small"
                  />
                </div>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_disabled">Version Used for Sync</label>
                  <ComponentTextInput
                    control={control}
                    isDisable
                    // handleChange={handleChange}
                    name={UnitInfoOrderFormNames.version}
                    id={UnitInfoOrderFormNames.version}
                    size="small"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Card>
      </Grid>
      <Grid item md={12} sm={12} xs={12} style={{ marginBottom: '20px' }}>
        <Card>
          <div className="double_checkbox_container">
            <CustomCheckbox name={UnitInfoOrderFormNames.serialVerified} label="Serial# is verified" isDisable control={control} />
          </div>
          <div className="customerInfo_main_container">
            <Grid container spacing={2}>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Manufacturer
                    <RequiredFiled />
                  </label>
                  <ComponentSelectInput
                    control={control}
                    name={UnitInfoOrderFormNames.manufacturer}
                    size="small"
                    errors={errors}
                    // handleChange={handleChange}
                    entries={unitMaster?.Manufacture || []}
                    disabled={!IsJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Machine Type
                    {/* <RequiredFiled /> */}
                  </label>
                  <ComponentSelectInput
                    disabled
                    control={control}
                    // errors={errors}
                    name={UnitInfoOrderFormNames.machineType}
                    size="small"
                    // handleChange={handleChange}
                    entries={machineType}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Model
                    <RequiredFiled />
                  </label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name={UnitInfoOrderFormNames.model}
                    inputProps={{ maxLength: 25 }}
                    // handleChange={handleChange}
                    errors={errors}
                    // regEx={/^[a-zA-Z0-9!@#$%^&*()_+{}[\]:;<>,.?~\\-\\/ ]{1,25}$/}
                    id={UnitInfoOrderFormNames.model}
                    size="small"
                    isDisable={!IsJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">Type</label>
                  <ComponentSelectInput
                    control={control}
                    name={UnitInfoOrderFormNames.type}
                    // handleChange={handleChange}
                    size="small"
                    entries={unitMaster?.Type || []}
                    disabled={!IsJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">Style</label>
                  <ComponentSelectInput
                    control={control}
                    name={UnitInfoOrderFormNames.style}
                    size="small"
                    // handleChange={handleChange}
                    entries={unitMaster?.Style || []}
                    disabled={!IsJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Serial #
                    <RequiredFiled />
                  </label>
                  <ComponentTextInput
                    control={control}
                    name={UnitInfoOrderFormNames.serialNumber}
                    id={UnitInfoOrderFormNames.serialNumber}
                    className="nonCapitalizeField"
                    inputProps={{ maxLength: 25 }}
                    errors={errors}
                    // handleChange={handleChange}
                    size="small"
                    isDisable={!IsJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Serial # on Site
                  </label>
                  <ComponentTextInput
                    control={control}
                    isDisable
                    name={UnitInfoOrderFormNames.serialNumberSite}
                    id={UnitInfoOrderFormNames.serialNumberSite}
                    className="nonCapitalizeField"
                    errors={errors}
                    inputProps={{ maxLength: 10 }}
                    // handleChange={handleChange}
                    size="small"
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Expenses
                  </label>
                  <ComponentTextInput
                    control={control}
                    isDisable
                    name={UnitInfoOrderFormNames.expenses}
                    id={UnitInfoOrderFormNames.expenses}
                    className="nonCapitalizeField"
                    inputProps={{ maxLength: 10 }}
                    // handleChange={handleChange}
                    size="small"
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    By
                  </label>
                  <ComponentTextInput
                    control={control}
                    isDisable
                    name={UnitInfoOrderFormNames.by}
                    id={UnitInfoOrderFormNames.by}
                    className="nonCapitalizeField"
                    inputProps={{ maxLength: 10 }}
                    // handleChange={handleChange}
                    size="small"
                  />
                </div>
              </Grid>
              <Grid item md={5} sm={10} xs={10}>
                <div className="div_label_text">
                  <label className="label_Style_job">Reviewed By</label>
                  <ComponentSelectInput
                    control={control}
                    name={UnitInfoOrderFormNames.reviewedBy}
                    size="small"
                    // handleChange={handleChange}
                    entries={signatures}
                    disabled={!IsJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={4} sm={2} xs={2}> </Grid>
              {/* {!JobOrderMainData?.IsMigrated && fields?.map((data, i) => (
                <Grid item md={3} sm={6} xs={12} key={data?.id} className="d-flex">
                  <div className="div_label_text width-90 mr10">
                    <label className="label_Style_job">
                      Inspected By
                      <RequiredFiled />
                    </label>
                    <ComponentSelectInputInspectedBy
                      control={control}
                      name={`${UnitInfoOrderFormNames.inspectedBy}.${i}`}
                      fieldName={UnitInfoOrderFormNames.inspectedBy}
                      size="small"
                      errors={errors}
                      i={i}
                      // required
                      // handleChange={handleChange}
                      entries={analystList || []}
                      disabled={!IsJobCompleted}
                    />
                  </div>
                  {IsJobCompleted && (
                  <div className={styles.AddPlaylistStyle} onClick={() => remove(i)} style={{ cursor: 'pointer' }}>
                    <DeleteIcon />
                  </div>
                  )}
                </Grid>
              ))} */}
              {!JobOrderMainData?.IsMigrated
  && fields?.map((data, i) => {
    // const inspectedByValue = data && typeof data === 'object'
    //   ? Object.entries(data)
    //     .filter(([key]) => key !== 'id')
    //     .sort(([a], [b]) => Number(a) - Number(b))
    //     .map(([, value]) => value)
    //     .join('')
    //   : '';
    const inspectedByText = data && typeof data === 'object'
      ? Object.entries(data)
        .filter(([key]) => key !== 'id')
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([, value]) => value)
        .join('')
      : '';

    const inspectedByValue = analystList?.find((option) => option.Text === inspectedByText)?.Value ?? inspectedByText;

    const isValueInDropdown = analystList?.some((option) => option.Value === inspectedByValue)
  || inspectedByValue === '';
    // Sync RHF value to the Value instead of the Text
    if (
      isValueInDropdown
  && inspectedByText
  && inspectedByText !== inspectedByValue
    ) {
      setValue(
        `${UnitInfoOrderFormNames.inspectedBy}.${i}`,
        inspectedByValue,
        { shouldDirty: false, shouldValidate: false },
      );
    }

    return (
      <Grid item md={3} sm={6} xs={12} key={data?.id} className="d-flex">
        <div className="div_label_text width-90 mr10">
          <label className="label_Style_job">
            Inspected By
            <RequiredFiled />
          </label>

          {isValueInDropdown ? (
            <ComponentSelectInputInspectedBy
              control={control}
              name={`${UnitInfoOrderFormNames.inspectedBy}.${i}`}
              fieldName={UnitInfoOrderFormNames.inspectedBy}
              size="small"
              errors={errors}
              i={i}
              entries={analystList || []}
              disabled={!IsJobCompleted}
            />
          ) : (
            <ComponentTextInput
              control={control}
              isDisable={!IsJobCompleted}
              name={`${UnitInfoOrderFormNames.inspectedBy}.${i}`}
              fieldName={UnitInfoOrderFormNames.inspectedBy}
              fieldI={i}
              id={UnitInfoOrderFormNames.inspectedBy}
              className="nonCapitalizeField"
              size="small"
              errors={errors}
            />
          )}
        </div>

        {IsJobCompleted && (
          <div
            className={styles.AddPlaylistStyle}
            onClick={() => remove(i)}
            style={{ cursor: 'pointer' }}
          >
            <DeleteIcon />
          </div>
        )}
      </Grid>
    );
  })}
              {IsJobCompleted && !JobOrderMainData?.IsMigrated && (
              <Grid item md={12} sm={12} xs={12}>
                <div
                  className={styles.AddPlaylistStyle}
                  onClick={() => append('')}
                  title="Add Inspected By"
                  style={{ cursor: 'pointer', marginTop: '0px', maxWidth: '25px' }}
                >
                  <AddPlaylist />
                </div>
              </Grid>
              )}
              {JobOrderMainData?.IsMigrated && (
              <Grid item md={6} sm={12} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">Inspected By</label>
                  <ComponentTextInput
                    control={control}
                    id={UnitInfoOrderFormNames.inspectedBy}
                    name={UnitInfoOrderFormNames.inspectedBy}
                    size="small"
                    // handleChange={handleChange}
                    isDisable={!IsJobCompleted}
                    multiline
                    rowSize={4}
                    className="nonCapitalizeField"
                  />
                </div>
              </Grid>
              )}
            </Grid>
          </div>
        </Card>
      </Grid>
      <Grid item md={12} sm={12} xs={12} style={{ marginBottom: '24px' }}>
        <Card>
          <div className="customerInfo_container">
            <div className="customerInfo">
              Spot Test
            </div>
          </div>
          <div className="customerInfo_main_container">
            <Grid container spacing={2}>
              <Grid item md={12} sm={12} xs={12}>
                <div className="unit_test_style">
                  <div>
                    <label>&nbsp;</label>
                    <CustomCheckbox
                      name={UnitInfoOrderFormNames.spotTest}
                      handleChange={handlePCTChange}
                      label="Spot Test"
                      control={control}
                      isDisable={!IsJobCompleted}
                    />
                  </div>
                  <div className="div_label_text">
                    <label className="label_Style_job">
                      Pct.
                      {spotTest && <RequiredFiled />}
                    </label>
                    <ComponentTextInput
                      control={control}
                      regEx={pctRegex}
                      type="number"
                      name={UnitInfoOrderFormNames.pct}
                      id={UnitInfoOrderFormNames.pct}
                      isDisable={!spotTest || !IsJobCompleted}
                      errors={errors}
                      onKeyDown={(e: { key: string; preventDefault: () => void; }) => {
                        if (['e', 'E', '-', '+'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      // handleChange={handleChange}
                      size="small"
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Card>
      </Grid>
      <Grid item md={12} sm={12} xs={12}>
        <div className="save_and_next_div">
          <div>
            <Button className="button_cancel" onClick={() => navigate(`/${EndPoints.JOB_ORDER}`)}>Cancel</Button>
          </div>
          <div className="button_margin_left">
            <Button disabled={buttonDisabled} type="submit" className="button_save_and_next">Next</Button>
          </div>
        </div>
      </Grid>
    </form>
  );
}

export default ScreenMain;
